var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 28,
    viewBox: "0 0 17 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7461 13.1534L10.5813 11.373L8.21494 19.5828L5.8486 11.373L1.68374 13.1534C0.737283 13.5491 0.169106 14.6372 0.358583 15.6262L1.96762 25.2206C2.15678 26.2096 3.10355 27.001 4.05009 27.001H12.3795C13.326 27.001 14.2725 26.2096 14.462 25.2206L16.071 15.6262C16.2609 14.6369 15.693 13.4501 14.7462 13.1534H14.7461Z",
    fill: "#1C7BDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5685 5.43761C12.5685 7.95075 10.6191 9.98779 8.21443 9.98779C5.80971 9.98779 3.86035 7.95075 3.86035 5.43761C3.86035 2.92483 5.80971 0.887695 8.21443 0.887695C10.6191 0.887695 12.5685 2.92474 12.5685 5.43761Z",
    fill: "#1C7BDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/male_icon.7b120f0946c4873642850cf79bb03313.svg";
export { ForwardRef as ReactComponent };